import SubProgram from '@/api/sub-program'
import ClassTeaching from '@/api/class-teaching'
import StudentProfile from '@/api/student-profile'

import { baseState, baseMutations } from '@/store/mixins'
import moment from 'moment'

export const state = {
  ...baseState,
  date_from: moment().format('DD-MM-YYYY'),
  date_to: moment().format('DD-MM-YYYY'),
  studentStatus: [],
  status_id: 1
}

export const getters = {}

export const mutations = {
  ...baseMutations,
  SET_DATE_FROM(state, date) {
    state.date_from = date
  },
  SET_DATE_TO(state, date) {
    state.date_to = date
  },
  SET_STATUS(state, data) {
    state.studentStatus = data
  },
  SET_STATUS_ID(state, data) {
    state.status_id = data
  }
}

export const actions = {
  getSubProgram(context, attributes = {}) {
    return SubProgram.get({
      params: Object.assign(
        {
          fields: {
            academic_program_subs: 'acps_id,acps_name_foreign'
          },
          page: -1
        },
        attributes
      ),
      headers: {
        'X-PERMISSION-ALLOW-CODE': context.rootGetters.permissionAllowCode
      }
    })
  },
  // preview monthly class teaching list
  fetchClassTeaching(context, attrubutes = {}) {
    let params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        search: context.state.search,
        status_id: context.state.status_id,
        date_from: context.state.date_from,
        date_to: context.state.date_to
      },
      attrubutes
    )
    return ClassTeaching.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },
  // preview monthly class teaching list
  fetchDetail(context, attrubutes = {}) {
    return ClassTeaching.getDetails(attrubutes)
  },
  excel(context, attributes) {
    return ClassTeaching.exportExcel(attributes)
  },
  async getStudentStatus(context) {
    if (!context.state.studentStatus.length > 0) {
      let response = await StudentProfile.getStatus()
      context.commit('SET_STATUS', response.data)
    }
  }
}
